import documentsDelivery from './documents-delivery.ts';
import file from './file.ts';
import invoice from './invoice.ts';
import person from './person.ts';
import crm from './crm.ts';
import dictionary from './dictionary.ts';
import external from './external.ts';
import ksef from './ksef.ts';
import ksefInvoices from './ksefInvoices.ts';
import closedMonth from './closedMonth.ts';
import mailing from './mailing.ts';
import twoFactor from './two-factor.ts';

export default {
    documentsDelivery,
    file,
    invoice,
    person,
    crm,
    dictionary,
    external,
    ksef,
    ksefInvoices,
    closedMonth,
    mailing,
    twoFactor,
};
